import DataComponent from './_data-component';
import autobind from 'core-decorators/lib/autobind';


export default class DataLoader extends DataComponent {

  componentDidMount() {
    this.loadDataDebounced(false);
  }

  componentDidUpdate(prevProps) {
    if (this.willBeSomethingChanged(prevProps, this.dependencies)) {
      this.loadDataDebounced(true);
    }
  }

  willBeSomethingChanged(nextProps, dependencies) {
    return _.some(dependencies, namespace => {
      const currentValue = _.get(this.props, namespace);
      const nextValue = _.get(nextProps, namespace);

      return !_.isEqual(currentValue, nextValue);
    });
  }

  loadData() {
    return null;
  }

  dependencies = [];
  isNeedReload = false;
  currentLoadingPromise = null;

  state = {
    isFetching: false,
  };

  @autobind
  loadDataDebounced(force) {
    if (this.currentLoadingPromise) {
      this.isNeedReload = true;
      return;
    }

    const promise = this.loadData(force);
    if (!promise) {
      return;
    }

    this.setState({
      isFetching: true,
    });

    this.currentLoadingPromise = promise.then(res => {
      this.currentLoadingPromise = null;
      if (this.isNeedReload) {
        this.isNeedReload = false;
        this.loadDataDebounced(force);
      }
      this.setState({
        isFetching: false,
      });
      return res;
    });
  }

  onceAtTime(fn) {
    return (...args) => {
      if (this._loading) {
        return;
      }
      this._loading = true;
      fn(...args)
        .then(() => {
          this._loading = false;
        })
        .catch(() => {
          this._loading = false;
        });
    };
  }
}



// WEBPACK FOOTER //
// ./src/shared/data-components/_data-loader.js